import Logo from 'assets/logo.svg';
import CircularLoading from 'components/CircularLoading';
import { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import theme from 'theme';

import { Box, Grid, Paper, Typography } from '@mui/material';
import { AuthService, IActivateResponse } from 'services';
import SuccessIcon from 'assets/success_icon.svg';

export const Activation: FC = () => {
  const [activation, setActivation] = useState<IActivateResponse>({
    status: false,
    role: undefined,
    error: '',
  });

  const { replace } = useHistory();
  const { token }: any = useParams();

  useEffect(() => {
    AuthService.activate(token).then((data: IActivateResponse) => {
      setActivation(data);

      if (data.status && data?.role === 'vet') {
        setTimeout(() => {
          replace('/vet');
        }, 6000);
      }
    });
  }, [token, replace]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: '100vh' }}
    >
      <Paper variant="outlined" sx={{ py: 8, px: 8, minWidth: '34vw' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            fontSize={24}
            fontWeight={400}
          >
            Bem-vindo ao{' '}
            <Typography
              fontSize={24}
              component="span"
              color={theme.palette.primary.main}
            >
              Vet4all
            </Typography>
            !
          </Typography>

          {activation.status ? (
            <>
              <Box my={4} component="img" alt="Ícone conta" src={SuccessIcon} />

              <Typography textAlign="center" fontWeight={500}>
                Sua conta foi ativada.
              </Typography>

              {activation.role === 'tutor' ? (
                <Typography textAlign="center" mt={1}>
                  Volte ao aplicativo e insira suas credenciais de acesso.
                </Typography>
              ) : (
                <Typography textAlign="center" mt={1}>
                  Você será redirecionado à tela de login, para realizar seu
                  primeiro acesso.
                </Typography>
              )}
            </>
          ) : (
            <>
              <Box my={4} component="img" alt="Logo" src={Logo} />

              {activation.error ? (
                <Typography
                  textAlign="center"
                  mt={2}
                  fontWeight={500}
                  color={theme.palette.error.main}
                >
                  {activation.error}
                </Typography>
              ) : (
                <>
                  <CircularLoading />

                  <Typography textAlign="center" mt={2} fontWeight={500}>
                    Estamos ativando sua conta...
                  </Typography>
                </>
              )}
            </>
          )}
        </Box>
      </Paper>
    </Grid>
  );
};

